import { FC } from 'react';
import { Button } from '@components/common/Button';
import { CircularLoader } from '@components/common/CircularLoader';
import { LoadingButtonProps } from './types';

export const LoadingButton: FC<LoadingButtonProps> = ({ buttonProps, circularProgressProps, isLoading, children }) => {
  return (
    <Button {...buttonProps} disabled={buttonProps?.disabled || isLoading}>
      <span className={'relative inline-flex items-center justify-center'}>
        <span className={isLoading ? 'invisible' : undefined}>{children}</span>
        {isLoading ? (
          <span className={'absolute inset-0 flex items-center justify-center'}>
            <CircularLoader
              size={circularProgressProps?.size ?? 20}
              className={circularProgressProps?.className}
              color={'inherit'}
            />
          </span>
        ) : null}
      </span>
    </Button>
  );
};
